// extracted by mini-css-extract-plugin
export default {"mapTypeControl":"MapTypeControl--mapTypeControl--Ra2k5","select":"MapTypeControl--select--lXpT1"};